export default __webpack_public_path__ + "locales/de/Payments.json?hash=b806688fcacc31f3b44464be7889e82d";